// extracted by mini-css-extract-plugin
export default {"tv_loader__wrapper":"Loader_tv_loader__wrapper__NYFMd","overlay":"Loader_overlay__GxroS","spinner":"Loader_spinner__e7xTm"};